var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMostCloudyDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 28.2814,
    r: 18,
    fill: "url(#paint0_linear_59_27029)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 68.7814H34.5H36H55.5C64.6127 68.7814 72 61.3941 72 52.2814C72 43.1687 64.6127 35.7814 55.5 35.7814C55.1382 35.7814 54.7791 35.793 54.4231 35.816C50.6566 28.6604 43.1481 23.7814 34.5 23.7814C23.6003 23.7814 14.5107 31.5318 12.4418 41.8222C5.48057 42.362 0 48.1816 0 55.2814C0 62.7372 6.04416 68.7814 13.5 68.7814Z",
    fill: "#E7F1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 68.7814H34.5H36H55.5C64.6127 68.7814 72 61.3941 72 52.2814C72 43.1687 64.6127 35.7814 55.5 35.7814C55.1382 35.7814 54.7791 35.793 54.4231 35.816C50.6566 28.6604 43.1481 23.7814 34.5 23.7814C23.6003 23.7814 14.5107 31.5318 12.4418 41.8222C5.48057 42.362 0 48.1816 0 55.2814C0 62.7372 6.04416 68.7814 13.5 68.7814Z",
    fill: "url(#paint1_linear_59_27029)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 68.7814H34.5H36H55.5C64.6127 68.7814 72 61.3941 72 52.2814C72 43.1687 64.6127 35.7814 55.5 35.7814C55.1382 35.7814 54.7791 35.793 54.4231 35.816C50.6566 28.6604 43.1481 23.7814 34.5 23.7814C23.6003 23.7814 14.5107 31.5318 12.4418 41.8222C5.48057 42.362 0 48.1816 0 55.2814C0 62.7372 6.04416 68.7814 13.5 68.7814Z",
    fill: "url(#paint2_linear_59_27029)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.2814C0 47.8255 6.04416 41.7814 13.5 41.7814H18C27.9411 41.7814 36 49.8402 36 59.7814V68.7814H13.5C6.04416 68.7814 0 62.7372 0 55.2814Z",
    fill: "url(#paint3_radial_59_27029)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46.2814C12 33.855 22.0736 23.7814 34.5 23.7814C46.9264 23.7814 57 33.855 57 46.2814C57 58.7078 46.9264 68.7814 34.5 68.7814C22.0736 68.7814 12 58.7078 12 46.2814Z",
    fill: "url(#paint4_radial_59_27029)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 52.2814,
    r: 16.5,
    fill: "url(#paint5_radial_59_27029)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_27029",
    x1: 59.1,
    y1: 36.0814,
    x2: 29.7478,
    y2: 0.256934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6D0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56298,
    stopColor: "#EEB82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB649",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_27029",
    x1: 22.5,
    y1: 34.2814,
    x2: 36,
    y2: 68.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89AFD1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_27029",
    x1: 32.0998,
    y1: 70.3739,
    x2: 31.1538,
    y2: 23.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257422,
    stopColor: "#93C2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_59_27029",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5 68.7814) rotate(-127.875) scale(28.5044 32.9871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.683784,
    stopColor: "#8FABDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5582D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_59_27029",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5 64.2814) rotate(-90) scale(40.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598765,
    stopColor: "#C7DFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B97E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_59_27029",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7 64.3814) rotate(-56.3099) scale(31.7288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47771,
    stopColor: "#8FABDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5582D3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostCloudyDay);
export default __webpack_public_path__ + "static/media/MostCloudyDay.13b2775c23a35c4cc7078aa4b7141ca8.svg";
export { ForwardRef as ReactComponent };